import { Grid } from '@material-ui/core';
import { Button, DateField, StandardDialog } from '@roc/ui';
import { format } from 'date-fns';
import { isValid } from 'date-fns/esm';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { PayoffCalculator } from './payoffCalculator';
import { useDocumentStore } from 'libs/feature-documents/src/documents/hooks/useDocumentStore';

interface IPrePayoffCaculatorDialogProps {
  open: boolean;
  onCLose: () => void;
}

export const PrePayoffCaculatorDialog = observer(({ open, onCLose, }: IPrePayoffCaculatorDialogProps) => {
  const {
    documentStore: {
      documentFormStore: { payoffCalculatorStore },
    },
  } = useDocumentStore();

  const [formattedDate, setFormattedDate] = useState(null)
  const [dateSubmitted, setDateSubmitted] = useState<boolean>(false);

  const manageDate = newDate => {
    const newFormattedDate = isValid(newDate) ? format(newDate, 'MM/dd/yyyy') : null;
    setFormattedDate(newFormattedDate);
    payoffCalculatorStore.setDateForPrePayoffCalculator(newFormattedDate);
  };

  useEffect(() => {
    if (open) {
      const newFormattedDate = format(new Date(), 'MM/dd/yyyy');
      setFormattedDate(newFormattedDate);
      setDateSubmitted(false);
      payoffCalculatorStore.setDateForPrePayoffCalculator(newFormattedDate);
      payoffCalculatorStore.setIsPrePayoffCalculator(true);
    }
  }, [open])


  const getContent = () => {
    if (dateSubmitted) {
      return (
        <PayoffCalculator />
      )
    }
    return (
      <Grid container>
        <Grid item xs={12}>
          <DateField
            label={"Good Through Date"}
            testId="paid-formatted-date"
            format="MM/dd/yyyy"
            inputVariant="outlined"
            standaloneLabel
            fullWidth
            value={formattedDate}
            onChange={newDate => manageDate(newDate)}
          />
        </Grid>
      </Grid>
    );
  }

  return (
    <StandardDialog
      open={open}
      title={"Payoff Calculator"}
      maxWidth={dateSubmitted ? "xl" : "sm"}
      handleClose={onCLose}
      dialogContent={
        getContent()
      }
      dialogActions={(
        !dateSubmitted && (
          <>
            <Button
              style={{ marginRight: '8px' }}
              onClick={onCLose}
              color="primary"
              variant="outlined"
              testId="cancel"
            >
              Cancel
            </Button>
            <Button
              onClick={() => setDateSubmitted(true)}
              color="primary"
              variant="contained"
              testId="confirm"
              disabled={!formattedDate}
            >
              Submit
            </Button>
          </>
        )
      )}
    />
  );

});
